function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* eslint-disable */ // ReSharper disable InconsistentNaming
export class GooglePlacesClient {
    searchOpeningHours(placeId) {
        let url_ = this.baseUrl + "/api/v1/places?";
        if (placeId !== undefined && placeId !== null) url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processSearchOpeningHours(_response);
        });
    }
    processSearchOpeningHours(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    refreshOpeningHours(token) {
        let url_ = this.baseUrl + "/api/v1/places/refresh?";
        if (token !== undefined && token !== null) url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.http.fetch(url_, options_).then((_response)=>{
            return this.processRefreshOpeningHours(_response);
        });
    }
    processRefreshOpeningHours(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k)=>_headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText)=>{
                let result200 = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText)=>{
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    constructor(baseUrl, http){
        _define_property(this, "http", void 0);
        _define_property(this, "baseUrl", void 0);
        _define_property(this, "jsonParseReviver", undefined);
        this.http = http ? http : window;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }
}
export class ApiException extends Error {
    static isApiException(obj) {
        return obj.isApiException === true;
    }
    constructor(message, status, response, headers, result){
        super(), _define_property(this, "message", void 0), _define_property(this, "status", void 0), _define_property(this, "response", void 0), _define_property(this, "headers", void 0), _define_property(this, "result", void 0), _define_property(this, "isApiException", true);
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}
